<template>
  <div class="album">
    <tip></tip>
    <template v-if="aciObj.enable">
      <empty></empty>
    </template>
    <template v-else>
      <div class="audioTitle">
        <!-- 合辑 -->
        <div class="title-content">
          <div class="surface_pic">
            <img :src="aciObj.pic" alt="">
            <div class="zhuanji">专辑</div>
          </div>
          <div class="title-right">
            <h3 v-if="aciObj.name">{{aciObj.name.slice(0,18)}}</h3>
            <div class="author_name">
              <img :src="aciObj.uavatar" alt="">
              <span v-if="aciObj.uname">{{aciObj.uname.slice(0,18)}}</span>
            </div>
          </div>
        </div>
        <div class="synopsis">
          <p class="synopsis-text" :class="{ zhankai: !iszhankai }">简介：{{aciObj.description}}</p>
          <span @click="zhankaiFn" v-if="aciObj.description && aciObj.description.length > 48">
          <img v-if="!iszhankai" src="../../assets/img/zhankan.png" alt="">
          <img v-if="iszhankai" src="../../assets/img/shouqi.png" alt="">
        </span>
        </div>
      </div>
      <div class="conntent" v-if="!isData">
        <div class="video_btnn">
          <div class="video_count">
            共{{books.length}}篇文本内容
          </div>
        </div>
      </div>
      <div class="video-list">
        <div class="audio-album" v-for="(aci) in books" :key="aci.id" @click="topageDetail(aci.guid,aci.view_pass)">
          <p class="album-title">
            <span>{{aci.name}}</span>
          </p>
          <span class="album-btn">
          <img v-if="aci.view_pass&&!canView"  src="../../assets/img/doc-lock.png" alt="">
          <img v-else src="../../assets/img/goto.png" alt="">
        </span>
        </div>
        <div v-if="isData" class="isData">
          当前页面没有内容或内容已下架
        </div>
      </div>


      <audioBtn
          v-if="audioUrl"
          ref="audioBtn"
          :url="audioUrl"
      >
      </audioBtn>
      <Dialog
          :visible="showDialog"
          title="输入密码，解锁内容"
          @close="showDialog = false"
          @cancel="showDialog = false"
          @confirm="handleConfirm"
      />
    </template>

  </div>
</template>

<script>
import tip from '@/components/tip.vue';
import empty from '@/components/empty.vue'
import audioBtn from '@/components/audioBtn.vue';
import {Base64} from 'js-base64';
import {Indicator, Toast} from 'mint-ui';
import Vue from 'vue';
import wechat from '@/plugins/wx';
import Dialog from "@/components/dialog.vue";
export default {
  components: {
    Dialog,
    tip,
    audioBtn,
    empty,
  },
  data() {
    return {
      iszhankai: false,
      aciObj: {},
      audioList: [],
      albumsList: [],
      albumObj: {},
      id: 0,
      // iszhankai: false,
      audioUrl: '',
      palyIng: false,
      timer: null,
      index: 0,
      outIndex: 0,
      playAll: false,
      activeIndex: -1,
      isData: false,
      shareConfig: {
        title: '分享标题',
        desc: '这是一个测试的微信分享',
        link: 'https://example.com', // 分享链接
        imgUrl: 'https://example.com/image.jpg', // 分享图标
      },
      books:[],
      canView:false,
      showDialog:false,
    }
  },
  created () {
    this.id = this.$route.query.id || 1
    this.getaudioList()
    this.report(this.id,9)
  },
  mounted() {
    // 初始化微信 JSSDK 配置
    const currentUrl = window.location.href.split('#')[0];
    wechat.initConfig(currentUrl).then(() => {
      // 配置分享内容
      wechat.setShareOptions(this.shareConfig);
    });
  },
  methods: {
    zhankaiFn(){
      this.iszhankai = !this.iszhankai
    },
    async report(id,dt) {
      try {
        // 发送点击事件请求到服务端
        await this.$report.sendReport({
          "id": id,
          "dt":dt
        });

      } catch (error) {
        console.error("Error sending click request:", error);
      }
    },
    closeFn(){
      this.activeIndex = -1
    },
    topage(){
      this.$router.push(`/audioList?id=${this.$route.query.id}`)
    },
    topageList(id){
      this.$router.push(`/audioList?id=${id}`)
    },
    topageDetail(id,view_pass){
      if(!this.canView&&view_pass!=""){
        this.showDialog = true;
        return;
      }
      this.$router.push(`/bookDetail?id=${id}`)
    },
    handleConfirm(value) {
      if(value==this.aciObj.view_pass){
        localStorage.setItem(`bookList-auth-${this.id}`, value);
        this.showDialog = false
        this.canView = true;
      }else{
        Toast({
          message:'密码不对！',
        });
      }

    },
    lengthFnn(duration) {
      let tTime = duration;
      let m = Math.floor(tTime%3600/60);
      let s = Math.floor(tTime%60);
      m = m>=10?m:"0"+m
      s = s>=10?s:"0"+s
      return m+":"+s
    },
    async playBtn(url){
      const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/v1/storage/qiniu/audio/${url}`)
      console.log(res)
    },
    pauseFn(item){
      this.playAll = false
      item.palyIng = false
      this.palyIng = false
      this.$refs.audioBtn.onPause()
      clearInterval(this.timer)

    },
    playAllFn(){
      this.playAll = true
      if(this.activeIndex >= 0){
        this.playFn(this.albumsList[this.activeIndex].list[0], 0, this.activeIndex)
      }else{
        this.activeIndex = 0
        this.playFn(this.albumsList[this.activeIndex].list[0], 0, 0)
      }
    },
    // 播放
    async playFn(item, index, k){
      this.index = index
      this.audioUrl = ''
      this.palyIng = true
      this.outIndex = k
      // 清空其他的
      this.albumsList.forEach(n =>{
        n.list.forEach(i =>{
          if(i !== item){
            i.palyIng = false
            i.currentTime = 0
            i.isActive = false
          }
        })
      })
      // 清空其他的
      this.audioList = this.albumsList[k].list || []
      clearInterval(this.timer)
      // 如果是已经播放过的，不需要请求，直接播放
      if(item.audioUrl){
        this.audioUrl = item.audioUrl
        item.palyIng = true
        item.isActive = true
        this.$nextTick(()=>{
          this.$refs.audioBtn.onPlay()
          this.timer = setInterval(() => {
            // 判断超时
            this.toTopFn(item, index, k)
          }, 1000)
        })
      }else{
        // 没有播放过，需要请求一下音频
        try {
          const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/v1/storage/qiniu/audio/${Base64.encode(item.url)}`)
          this.audioUrl = res.data.data
          item.audioUrl = res.data.data
          item.palyIng = true
          item.isActive = true
          this.$nextTick(()=>{
            if(this.$refs.audioBtn.isOk){
              this.$refs.audioBtn.onPlay()
              this.timer = setInterval(() => {
                // 判断超时
                this.toTopFn(item, index, k)
              }, 1000)
            }else{
              const time33 = setInterval(() => {
                if(this.$refs.audioBtn.isOk){
                  clearInterval(time33)
                  this.$refs.audioBtn.onPlay()
                  this.timer = setInterval(() => {
                    // 判断超时
                    this.toTopFn(item, index, k)
                  }, 1000)
                }
              }, 300)
            }
          })
        } catch (err) {
          console.log(err)
        }
      }
    },
    toTopFn(item, index, k){
      item.currentTime = Math.round(this.$refs.audioBtn.$refs.audio.currentTime)
      if(item.currentTime >= item.length ){
        clearInterval(this.timer)
        if(this.playAll && index+1 < this.audioList.length){
          this.playFn(this.albumsList[k].list[index+1], index+1, k)
        }else{
          item.currentTime = 0
          item.palyIng = false
          this.playAll = false
          this.palyIng = false
        }
      }
    },
    // 获取合辑数据
    async getaudioList() {
      try {
        Indicator.open()
        this.id = this.$route.query.id || 1
        const res = await this.axios.get(`https://api.ayerdudu.com/v1/book/album/${this.id}`)
        this.aciObj = res.data.data;
        console.log('文档专辑结果',this.aciObj)
        this.albumsList = this.aciObj.books;
        this.books = this.aciObj.books;
        const currentUrl = window.location.href.split('#')[0];
        this.shareConfig.title = this.aciObj.name;
        this.shareConfig.desc = this.aciObj.description;
        this.shareConfig.link = currentUrl;
        this.shareConfig.imgUrl = this.aciObj.pic;
        console.log('分享配置',this.shareConfig);
        //const currentUrl = 'http://videos.ayerdudu.com/audioDetail?id=d1b469a1-91f4-1400-d29e-241571036c3c';
        wechat.initConfig(currentUrl).then(() => {
          // 配置分享内容
          wechat.setShareOptions(this.shareConfig);
        });
        // this.albumsList.forEach(item => {
        //   Vue.set(item, 'rows', 0)
        // })
        //this.getalbumList(this.albumsList[0], 0, false, false)
        this.canView = this.$checkViewPass("bookList-auth-"+this.id,this.aciObj.view_pass);
        Indicator.close()
        if(!this.albumsList.length){
          this.isData = true
        }
      } catch (err) {
        console.log(err)
        this.isData = true
        Indicator.close()
      }
    },
    getMore(aci, k ){
      console.log('aci', aci)
      aci.pageNumber++
      this.getalbumList(aci, k, true, true)
    },
    // 获取专辑数据
    async getalbumList(itemList, k, pushArr = false, falg = true) {
      // itemList ,获取id 和 pageNumber
      // k 获取索引
      // pushArr ，判断是打开还是加载更多
      let pageNumber = 1
      if(itemList.pageNumber){
        pageNumber = itemList.pageNumber
      }
      if(!this.albumsList[k].list.length || pushArr){
        try {
          const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/v1/audio/audios?pageNumber=${pageNumber}&pageSize=20&orderField=created_at&sort=asc&albumid=${itemList.id}`)
          if(pushArr){
            const pushArr = res.data.data
            pushArr.forEach(item => {
              Vue.set(item, 'palyIng', false)
              Vue.set(item, 'currentTime', 0)
              Vue.set(item, 'audioUrl', '')
              Vue.set(item, 'isActive', false)
            })
            this.albumsList[k].list = [...this.albumsList[k].list, ...pushArr]
          }else{
            this.albumsList[k].list = res.data.data
            this.albumsList[k].rows = res.data.rows
            Vue.set(this.albumsList[k], 'pageNumber', 1)
            this.albumsList[k].list.forEach(item => {
              Vue.set(item, 'palyIng', false)
              Vue.set(item, 'currentTime', 0)
              Vue.set(item, 'audioUrl', '')
              Vue.set(item, 'isActive', false)
              Vue.set(item, 'pageNumber', 1)
            })
          }
        } catch (err) {
          console.log(err)
        }
      }
      if(falg){
        this.$nextTick(()=>{
          this.activeIndex = k
        })
      }else{
        this.activeIndex = -1
      }
    }
  }
}
</script>

<style lang="less" scoped>
.album{
  width: 100%;
  min-height: 100%;
  //overflow: hidden;
  //overflow-y: scroll;
  background: #f6f6f6;
  &::-webkit-scrollbar {
    display: none;
  }
  .audioTitle{
    background-color: #fff;
  }
  .conntent{
    padding: 0 40px;
    height: 130px;
    background: #f6f6f6;
  }
}
.video_btnn{
  padding-top: 30px;
  width: 100%;
  height: 70px;
  .video_count{
    float: left;
    font-size: 33px;
    font-weight: bold;
    line-height: 72px;
  }
  .palyall{
    float: right;
    background-image: linear-gradient(to right, #fe7450 , #f6451b);
    padding: 19px 28px;
    border-radius: 40px;
    color: #fff;
    font-size: 22px;
    >div{
      >img{
        float: left;
        width: 20px;
        height: 26px;
        margin-right: 10px;
        margin-top: 3px;
      }
      >span{
        float: left;
        margin-bottom: -3px;
      }
    }
  }
}
.video-list{
  min-height: 30px;
  padding: 0 18px 100px;
  background: #f6f6f6;
  .item-audio{
    box-sizing: border-box;
    height: 124px;
    position: relative;
    padding: 30px 54px 0;
    .name{
      font-size: 28px;
      display: block;
      color: #000;
      margin-bottom: 5px;
    }
    .shichang{
      font-size: 22px;
      color: #888888;
    }
    .btn{
      position: absolute;
      display: block;
      width: 50px;
      height: 50px;
      overflow: hidden;
      right: 28px;
      top: 45px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    &.active{
      .name{
        color: #f6451b;
      }
      .shichang{
        color: #f6451b;
      }
    }
  }
  .more-tip{
    text-align: center;
    color: #aaa;
    font-size: 22px;
    line-height: 124px;
  }
}
.audio-album{
  min-height: 137px;
  position: relative;
  // box-shadow:2px 2px 1px #aaaaaa;
  border-radius: 20px;
  background: #fff;
  margin-bottom: 20px;
  .album-title{
    font-size: 31px;
    font-weight: bold;
    line-height: 137px;
    text-indent: 30px;
  }
  .album-btn{
    display: block;
    position: absolute;
    top: 50px;
    right: 30px;
    width: 42px;
    height: 42px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.isData{
  line-height: 100px;
  text-align: center;
  font-size: 30px;
}
.audioTitle{
  min-height: 200px;
  padding: 24px 36px;
}
.title-content{
  height: 250px;
  display: flex;
  .surface_pic{
    width: 250px;
    height: 250px;
    position: relative;
    overflow: hidden;
    border: 1px solid #eee;
    border-radius: 18px;
    img{
      width: 100%;
      height: 100%;
      // border-radius: 10px;
    }
    .zhuanji{
      position: absolute;
      top: -50px;
      right: -46px;
      background: #22b07d;
      color: #fff;
      width: 112px;
      height: 112px;
      border-radius: 50%;
      line-height: 160px;
      font-size: 24px;
      text-indent: 12px;
      // transform: scale(0.7);
    }
  }
  .title-right{
    flex: 1;
    margin-left: 40px;
    h3{
      line-height: 54px;
      font-size: 38px;
      margin: 30px 0 15px 0;
      color: #000;
      font-weight: bold;
    }
    .author_name{
      height: 46px;
      font-size: 0;
      img{
        width: 44px;
        height: 44px;
        border-radius: 50%;
        border: 1px solid #eee;
        overflow: hidden;
        float: left;
      }
      >span{
        float: left;
        line-height: 52px;
        margin-left: 12px;
        font-size: 25px;
      }
    }
  }
  margin-bottom: 32px;
}
.synopsis{
  font-size: 24px;
  color: #888;
  line-height: 36px;
  display: flex;
  .synopsis-text{
    flex: 1;
    line-height: 37px;
    &.zhankai{
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  >span{
    width: 20px;
    position: relative;
    cursor: pointer;
    >img{
      width: 30px;
      height: 30px;
      position: absolute;
      bottom: 0;
    }
  }
}

</style>